import { Language, Modality, MovieFormat } from "@multicines/types";

import { BasicInternationalization } from "types/common.types";

export const getModality = (
  modality: Modality | null,
  t: BasicInternationalization
) => {
  switch (modality) {
    case "All":
      return t.billboard;
    case "Premiere":
      return t.premiere;
    /* case "Presale":
      return t.presale; */
    case "Preview":
      return t.preview;
    default:
      break;
  }
};
export const getModalities: () => Modality[] = () => {
  return ["All", "Premiere", /* "Presale", */ "Preview"];
};

export const getLanguage = (language: string, t: BasicInternationalization) => {
  switch (language) {
    case "ESP":
      return t.spa;
    case "SUB":
      return t.sub;
    case "All":
      return t.all;
    default:
      break;
  }
};

export const getLanguages: () => Language[] = () => {
  return ["All", "ESP", "SUB"];
};

export const getFormats: () => MovieFormat[] = () => {
  return ["All", "2D", "3D", "4D"];
};
